module.exports = __webpack_public_path__ + "img/l8.19416fc0.png";